import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import $ from 'jquery';
import 'react-phone-input-2/lib/material.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/style.css';
import { Provider } from 'react-redux';
import {store} from "./config/store"
import NotificationProvider from './hoc/NotificationProvider';


// Now assign jQuery to the window object, after all imports
window.jQuery = $;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
       <NotificationProvider>
      <App />
      </NotificationProvider>
    </Provider>
  </StrictMode>,
);
